"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function columnWidth(node, region, cfg) {
    if (cfg === void 0) { cfg = { ratio: 0.6 }; }
    return region.width * cfg.ratio;
}
exports.default = {
    type: 'padding',
    usage: 'assign',
    expression: columnWidth,
};
//# sourceMappingURL=column-width.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/constraints/column-width.js
// module id = 1024
// module chunks = 37